<template>
    <tr v-if="option.values.length" class="text-sm">
        <td width="70%" class="text-gray-600">
            {{ option.attribute.title }}
        </td>

        <td width="30%">
            
            <!-- N/A -->
            <i class="text-gray-600 italic" v-if="!option.values.length">Niet bekend</i>

            <!-- Yes -->
            <div v-else-if="option.attribute.type == 'level'" class="flex w-16 h-4">
                <Levels :rating="parseFloat(option.values[0].value)" />
            </div>
        </td>
    </tr>
</template>

<script setup>
import Levels from '@/Blocks/Level.vue';

const props = defineProps({
    option: Object,
});
</script>
